import moment from "moment";

export class DateUtil {
    /** Formats a UTC-stored date-only field for display (YYYY-MM-DD). */
    static formatDisplay(date) {
        if (!date) return '-';
        return moment.utc(date).format("YYYY-MM-DD");
    }

    /** Formats a UTC-stored datetime field for display (YYYY-MM-DD HH:mm). */
    static formatDisplayDateTime(date) {
        if (!date) return '-';
        return moment.utc(date).format("YYYY-MM-DD HH:mm");
    }

    static formatYYYYMMDD(date) {
        return moment(date).format("YYYY-MM-DD");
    }
}